import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { useAppearance } from "@/context/AppearanceContext";
import { LogoSettings, BannerSettings } from "@/components/admin/appearance/LogoBannerSettings";
import { PackagesEditor } from "@/components/admin/appearance/PackagesEditor";
import { TextsForm, ThemeForm } from "@/components/admin/appearance/TextsThemeForms";

const TABS = [["logo", "Logo & Promo"], ["banner", "Banner Beranda"], ["harga", "Harga & Gambar Paket"], ["teks", "Teks Informasi"], ["tema", "Warna, Font & Tombol"]];

export const AppearancePanel = () => {
  const { can } = useAuth();
  const { texts } = useAppearance();
  const canManage = can("appearance", "manage");
  const [tab, setTab] = useState("logo");
  return (
    <section className="space-y-5" data-testid="appearance-panel">
      <div className="flex flex-wrap gap-1.5 rounded-xl border border-white/10 bg-[#0f0f15] p-1" data-testid="appearance-tabs">
        {TABS.map(([k, l]) => (
          <button key={k} onClick={() => setTab(k)} data-testid={`appearance-tab-${k}`}
            className={`rounded-lg px-4 py-2 text-xs font-semibold transition-colors ${tab === k ? "bg-[#e5b80b] text-black" : "text-zinc-400 hover:bg-white/5 hover:text-white"}`}>{l}</button>
        ))}
      </div>
      {!canManage ? <p className="text-xs text-zinc-500" data-testid="appearance-readonly">Mode lihat saja — minta izin MASTER untuk mengubah.</p> : null}
      {tab === "logo" ? <LogoSettings canManage={canManage} /> : null}
      {tab === "banner" ? <BannerSettings canManage={canManage} /> : null}
      {tab === "harga" ? <PackagesEditor canManage={canManage} /> : null}
      {tab === "teks" && texts ? <TextsForm canManage={canManage} /> : null}
      {tab === "tema" ? <ThemeForm canManage={canManage} /> : null}
    </section>
  );
};
